export const TABLE_REQUESTS_STATE_STRINGS = {
  errorLoadingRequests: 'Error loading requests',
  noRequestsFound: 'No requests found',
  noRequestsAvailable: 'No requests available',
} as const
